import { Component } from '@angular/core';

interface ProtocolStep {
  titleKey: string;
  bodyKey: string;
  accent: string;
}

interface PulseActivity {
  token: string;
  tokenColor: string;
  label: string;
  bodyPre: string;
  amount: string;
  amountColor: string;
  timestamp: string;
}

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss'],
  standalone: false,
})
export class FeatureComponent {
  readonly steps: ProtocolStep[] = [
    { titleKey: 'feature.step1_title', bodyKey: 'feature.step1_body', accent: '#69DAFF' },
    { titleKey: 'feature.step2_title', bodyKey: 'feature.step2_body', accent: '#C3F400' },
    { titleKey: 'feature.step3_title', bodyKey: 'feature.step3_body', accent: '#FF51FA' },
  ];

  // Marquee duplicated for seamless infinite scroll
  readonly activities: PulseActivity[] = [
    { token: 'SOL', tokenColor: '#69DAFF', label: 'PREDICTION RESOLVED', bodyPre: '0x7F...3B92 won ', amount: '$4,280',  amountColor: '#C3F400', timestamp: '2s ago'  },
    { token: 'BTC', tokenColor: '#FF51FA', label: 'NEW POSITION',        bodyPre: '0x2A...91C4 placed ', amount: '$1,500', amountColor: '#69DAFF', timestamp: '5s ago'  },
    { token: 'ETH', tokenColor: '#C3F400', label: 'MARKET CREATED',      bodyPre: 'ETH > $4,200 at 16:00 UTC', amount: '', amountColor: '#FFFFFF', timestamp: '12s ago' },
    { token: 'SOL', tokenColor: '#69DAFF', label: 'PREDICTION RESOLVED', bodyPre: '0x88...EF12 won ', amount: '$1,120',  amountColor: '#C3F400', timestamp: '18s ago' },
    { token: 'BTC', tokenColor: '#FF51FA', label: 'NEW POSITION',        bodyPre: '0x9C...4AD1 placed ', amount: '$800',  amountColor: '#69DAFF', timestamp: '24s ago' },
  ];
}
